import {
  Directive,
  forwardRef,
  Input
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator
} from '@angular/forms';

import { DATE_CONFIGURATIONS } from '../constants/date.configurations.constant';

@Directive({
  selector : '[worTimeValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => TimeValidator)
    }
  ]
})
export class TimeValidator implements Validator {
  private _defaultValidation = DATE_CONFIGURATIONS.time.validation;

  @Input('worTimeValidator') value: string;

  validate ( control: AbstractControl ) : { [ key: string ] : any } {
    return ( !control.value || this._defaultValidation.test(control.value) )
      ? null
      : { time: true };
  }
}